module.exports = __webpack_public_path__ + "img/chat_cn.b885c942.svg";